var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoundationColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47627 29.6346H12.9044C13.2181 29.6346 13.5189 29.7592 13.7407 29.981C13.9625 30.2028 14.0871 30.5036 14.0871 30.8173C14.0871 31.131 13.9625 31.4318 13.7407 31.6536C13.5189 31.8754 13.2181 32 12.9044 32H1.68272C1.36904 32 1.06822 31.8754 0.846414 31.6536C0.62461 31.4318 0.5 31.131 0.5 30.8173C0.5 30.5036 0.62461 30.2028 0.846414 29.981C1.06822 29.7592 1.36904 29.6346 1.68272 29.6346H6.11083V22.3868C5.79859 21.1852 4.17117 14.0416 7.53009 8.27934C11.1256 2.1008 18.9315 0.113829 19.2627 0.0381349C19.56 -0.0399081 19.8761 0.00285065 20.142 0.157078C20.408 0.311306 20.6021 0.564478 20.682 0.861312C20.7766 1.19247 22.9055 8.96059 19.31 15.1391C16.3863 20.1539 10.6903 22.4058 8.47627 23.1154V29.6346Z",
    fill: "#D2424B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundationColored);
export default __webpack_public_path__ + "static/media/FoundationColored.d6e3b2df8a6de97c259fbcb597ff7d6c.svg";
export { ForwardRef as ReactComponent };